import { defineComponent as r, openBlock as c, createBlock as n, unref as o, mergeProps as d, withCtx as p, createElementVNode as a } from "vue";
import { RevIcon as i } from "@ds/components/Icon";
const u = /* @__PURE__ */ r({
  name: "IconReassuranceCreditCardFilled",
  __name: "IconReassuranceCreditCardFilled",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(l) {
    const t = l;
    return (s, e) => (c(), n(o(i), d(t, { "view-box": "0 0 48 48" }), {
      default: p(() => [...e[0] || (e[0] = [
        a("g", {
          "fill-rule": "evenodd",
          "clip-path": "url(#a43cc9b7-3e46-4102-bf6f-cfea7a71b53da)",
          "clip-rule": "evenodd"
        }, [
          a("path", { d: "m18.83 7.32 16.08 3a3.42 3.42 0 0 1 2.24 1.47 3.48 3.48 0 0 1 .56 2.62l-4.38 23.42a3.51 3.51 0 0 1-4.09 2.8l-16.08-3a3.51 3.51 0 0 1-2.79-4.09l4.38-23.43a3.49 3.49 0 0 1 4.08-2.79m-4.283 26.821a.5.5 0 0 0 .173-.291l1.31-6.98a.5.5 0 0 0-.4-.59.51.51 0 0 0-.58.4l-1.31 7a.49.49 0 0 0 .4.58h.09a.5.5 0 0 0 .317-.119m3.004.615a.5.5 0 0 0 .169-.296l.49-2.48a.508.508 0 0 0-1-.18l-.47 2.48a.5.5 0 0 0 .4.59h.09a.5.5 0 0 0 .321-.114M29.11 18.28c-.41-.24-1.16.29-1.66 1.18l-.05-.05c-.5.89-.51 1.81-.1 2.05s1.14-.32 1.65-1.18.57-1.76.16-2m-3.51-2.29c-.67-.46-1.92.2-2.79 1.47l-.05-.07c-.86 1.27-1.03 2.65-.36 3.13s1.97-.13 2.84-1.4 1.03-2.67.36-3.13m.39 10.34a9 9 0 0 0 3.28 0l-.05-.07a.2.2 0 0 0 .14-.2.19.19 0 0 0-.18-.21 15 15 0 0 1-3-.61A12.4 12.4 0 0 1 23.46 24a11.2 11.2 0 0 1-2.29-1.87 22 22 0 0 1-2-2.36.25.25 0 0 0-.27-.09.25.25 0 0 0-.16.32 8.8 8.8 0 0 0 4.13 5.18 9.3 9.3 0 0 0 3.12 1.15" }),
          a("path", { d: "M10.666 4.045a24 24 0 1 1 26.668 39.91 24 24 0 0 1-26.668-39.91M34.31 38l4.38-23.41-.01-.01a4.5 4.5 0 0 0-3.6-5.25L19 6.33a4.5 4.5 0 0 0-5.24 3.6L9.4 33.36a4.52 4.52 0 0 0 3.6 5.25l16.06 2.99a5 5 0 0 0 .84.07A4.51 4.51 0 0 0 34.31 38" })
        ], -1),
        a("defs", null, [
          a("clipPath", { id: "a43cc9b7-3e46-4102-bf6f-cfea7a71b53da" }, [
            a("path", { d: "M0 0h48v48H0z" })
          ])
        ], -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  u as default
};
